export default function titleCase(txt = ''){
    return txt.charAt(0).toUpperCase() + txt.substr(1);
}